import { Icon as e } from "../Icon/index.js";
import { keyframes as r, styled as o } from "styled-components";
import { Theme as a } from "../../styles/themes/index.js";
import { H3Heavy as n } from "../../styles/typography/index.js";
import { ZIndex as d, MediaQuery as t, MODAL_OVERLAY as s } from "../../styles/variables.js";
import { Colors as p } from "../../styles/colors/index.js";
const m = "--border-radius", b = r`
  from {
		opacity: 1;
	}
	to {
		opacity: 0;
	}
`, y = o.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: ${d.MODAL_CONTAINER};
  display: flex;
  align-items: center;
  opacity: 1;
  transition: opacity 0.3s ease;
  animation: fadeOutKeyframes 0.3s ease;

  &[aria-hidden='true'] {
    opacity: 0;
  }
`, v = o.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px 24px 0 0;
  margin-bottom: -24px;
  max-height: 302px;
`, M = o.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  width: 100%;
  margin: 0px auto;
  z-index: 1;
  border-radius: var(${m}, 24px 24px 0 0);
  max-height: 100%;
  overflow-y: auto;

  &[data-modalPage='true'] {
    border-radius: unset;
  }

  @media ${t.SCREEN_MD_UP} {
    bottom: initial;
    border-radius: 24px;
    width: fit-content;
  }
`, _ = o.div`
  padding: 24px;
  width: 100%;
  justify-content: center;
  border-radius: 24px 24px 0 0;

  box-sizing: border-box;

  background: rgb(${a.colors.Juliet});

  @media ${t.SCREEN_LG_DOWN} {
    &[data-modalPage='true'] {
      height: 100vh;
      border-radius: unset;
    }
  }

  ${({ $extendesStyle: i }) => i || ""}
`, $ = o.div`
  width: 100vw;
  height: 100vh;
  background: ${s};
`, E = o(e)`
  color: rgb(${p.White});
  font-size: 32px;
  margin-left: auto;

  position: absolute;
  top: 9px;
  right: 20px;

  &:hover {
    cursor: pointer;
  }
`, l = o(e)`
  color: rgb(${a.colors.Alpha});
  font-size: 24px;
  margin-left: auto;

  @media ${t.SCREEN_MD_DOWN} {
    &[data-modalPage='true'] {
      margin-left: unset;
      margin-right: auto;
    }
  }

  &:hover {
    cursor: pointer;
  }
`, D = o.h2`
  ${n}

  @media ${t.SCREEN_MD_DOWN} {
    &[data-modalPage='true'] {
      margin-right: auto;
    }
  }

  + ${l} {
    top: 32px;
    right: 24px;
  }
`, O = o.div`
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
  margin-bottom: 16px;

  @media ${t.SCREEN_MD_DOWN} {
    &[data-modalPage='true'] {
      margin-right: auto;
      padding: unset;
    }
  }
`;
export {
  m as BORDER_RADIUS_VAR,
  v as ModalBanner,
  E as ModalBannerCloseButtonIcon,
  M as ModalBox,
  l as ModalCloseButtonIcon,
  y as ModalContainer,
  _ as ModalContent,
  O as ModalHeader,
  $ as ModalOverlay,
  D as ModalTitle,
  b as fadeOutKeyframes
};
